export let LiveSiteDispatchModalOpenedSchedulingType = /*#__PURE__*/function (LiveSiteDispatchModalOpenedSchedulingType) {
  LiveSiteDispatchModalOpenedSchedulingType["ASAP"] = "ASAP";
  LiveSiteDispatchModalOpenedSchedulingType["SAME_DAY"] = "SAME_DAY";
  LiveSiteDispatchModalOpenedSchedulingType["ASAP_AND_FUTURE"] = "ASAP_AND_FUTURE";
  LiveSiteDispatchModalOpenedSchedulingType["PRE_ORDER"] = "PRE_ORDER";
  return LiveSiteDispatchModalOpenedSchedulingType;
}({});
export let LiveSiteDispatchModalOpenedSelectedRadioButton = /*#__PURE__*/function (LiveSiteDispatchModalOpenedSelectedRadioButton) {
  LiveSiteDispatchModalOpenedSelectedRadioButton["ASAP_RADIO_BUTTON"] = "ASAP_RADIO_BUTTON";
  LiveSiteDispatchModalOpenedSelectedRadioButton["FUTURE_RADIO_BUTTON"] = "FUTURE_RADIO_BUTTON";
  return LiveSiteDispatchModalOpenedSelectedRadioButton;
}({});
//# sourceMappingURL=constants.js.map